import {MenuItem} from "@mui/material";
import {SelectWithLabel} from "../project/quote/hardware/SelectWithLabel";

export const doorBuilderPreps: {display: string, value: string}[] = [
    {display: "RP", value: "RP"},
    {display: "161", value: "161"},
    {display: "4.5\" STD", value: "4.5\" STD"},
];

export const frameBuilderPreps: {display: string, value: string}[] = [
    {display: "RP", value: "RP"},
    {display: "ASA", value: "ASA"},
    {display: "4.5\" STD", value: "4.5\" STD"},
    {display: "IMP", value: "IMP"},
    {display: "P&S", value: "P&S"},
    {display: "S&T", value: "S&T"},
];

export const frameHingePreps: {display: string, value: string}[] = [
    {display: "4.5\" STD", value: "4.5\" STD"},
];

export const frameStrikePreps: {display: string, value: string}[] = [
    {display: "RP", value: "RP"},
    {display: "ASA", value: "ASA"},
];

export function hasAnchorPrep(preps: string[]) {
    return preps.includes("IMP") || preps.includes("P&S") || preps.includes("S&T");
}

export function StandardPrepSelector(props: {
    optionList: {display: string, value: string}[];
    preps: string[];
    onChange(value: string[]): void;
    fullWidth?: boolean
}) {
    return (
        <SelectWithLabel style={{minWidth: 300}} fullWidth={props.fullWidth} size="small" label="Add Prep" multiple value={props.preps} onChange={e => props.onChange(e.target.value as any)}>
            {props.optionList.map(p => (
                <MenuItem key={p.value} value={p.value}>{p.display}</MenuItem>
            ))}
        </SelectWithLabel>
    )
}